export class Movimentacao {
    id: number;
    observacao: string;
    tipoMovimentacao: string;
    contaOrigem: number;
    contaDestino: number;
    valorMovimentacao: any;
    contaOrigemDescricao: string;
    contaDestinoDescricao: string;

    

    constructor( id: number, observacao: string, tipoMovimentacao: string, contaOrigem: number, contaDestino: number, valorMovimentacao: any
        ,contaOrigemDescricao: string,contaDestinoDescricao: string ) {
        this.id = id;
        this.observacao = observacao;
        this.tipoMovimentacao = tipoMovimentacao;
        this.contaOrigem = contaOrigem;
        this.contaDestino = contaDestino;
        this.valorMovimentacao = valorMovimentacao;
        this.contaOrigemDescricao = contaOrigemDescricao;
        this.contaDestinoDescricao = contaDestinoDescricao;        
    }
}